import React from 'react';
import { createGlobalStyle } from '@harver/shared-ui';

export const GlobalStyle: React.ComponentType<any> = createGlobalStyle<any>`
    html,
    body {
        width: 100%;
        height: 100%;
        color: ${({ theme }) => theme.colors.neutral['900']};
        overflow: hidden;
    }

    body {
        background-color: ${({ theme }) => theme.colors.neutral['025']};
    }

    html {
        font-size: 62.5%;
    }

    #root {
        width: 100vw;
        min-width: 320px;
        height: 100%;
    }
` as any;
